import { Box, styled } from '@mui/material';

export const TemporaryLogout = styled(Box)(({ theme }) => ({
  margin         : '10px',
  display        : 'flex',
  justifyContent : 'end',
  color          : theme.palette.primary.blue1,
  cursor         : 'pointer',
}));
